import {
  Box,
  Button,
  Card,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  styled,
  tableCellClasses,
} from "@mui/material";
import Dialog, { type DialogProps } from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import printIcon from "../../../assets/PrintIcon.svg";
import {
  CustomSelect,
  CustomMenuItem,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  StyledDateContainer,
  CustomRequiredInputLabel,
  CustomCheckbox,
  CustomTextFeild,
  CustomInputLabel,
  CommonButton,
  formatAmount,
  CommonOutlinedButton,
} from "../../common/StyledComponents/StyledFields";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useEffect, useRef, useState } from "react";
import styles from "./CustomReport.module.scss";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { apiRequest } from "../../../infrastructure/backendService";
import { useReactToPrint } from "react-to-print";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import CustomSelectField from "../../common/CustomSelectField/CustomSelectField";
import ViewExpenseRequest from "../PrintVoucher/ViewExpenseRequest/ViewExpenseRequest";
import Pagination from "../../common/pagination/pagination";
import { BounceLoader, ClipLoader } from "react-spinners";

const StyledTable = styled(Table)(({ theme }) => ({
  borderRadius: "8px",
  borderCollapse: "collapse", // Collapse borders to avoid doubled borders between cells
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  position: "relative",
  overflow: "auto",
  paddingBottom: "4px",
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#F2BE22", // Scrollbar color
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "transparent",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: " #FEBE00",
    fontWeight: "700",
    color: "#000",
    textAlign: "left",
    border: "1px solid #fff",
    padding: "10px",
    margin: "10px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    whiteSpace: "nowrap",
    textOrientation: "mixed",
    textAlign: "left",
    margin: 0,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  //   height: "-10px",
  "& td, & th": {
    margin: "10px",
    padding: "10px",
    border: "1px solid #fff",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#FFECB4", // Set odd rows to white
  },
  "&:nth-of-type(odd)": {
    backgroundColor: " #fff", // Set even rows to yellow
  },
}));

const formFieldsCustomReport = {
  budgetYear: new Date().getFullYear(),
  checkedMailMonth: "",
  checkedMailYear: "",
  submittedDateFilter: "",
  submittedBy: "",
  authorizedBy: "",
  amountFirst: "",
  amountSecond: "",
  amountThird: "",
  shortTitle: "",
  submittedDateOne: "",
  submittedDateTwo: "",
  status: "",
  devoteeSponsered: false,
  expensesEnteredMonth: "",
};

const CustomReport = () => {
  const [formData, setFormData] = useState(formFieldsCustomReport);
  // const [checkedItems, setCheckedItems] = useState<CheckedItems>({});
  const [isDevoteeSponsered, setIsDevoteeSponsered] = useState(false);
  const [openExpenseRequestDialog, setOpenExpenseRequestDialog] =
    useState(false);
  const [viewRequestDetails, setViewRequestDetails] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState<string>("");
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [ReportData, setReportData] = useState<any>("");
  const [authorizations, setAuthorizations] = useState<any[]>([]);
  const [grandSummaryData, setGrandSummaryData] = useState<any>("");
  const componentRef = useRef<any>(null);
  const [loading, setLoading] = useState(false);
  const [activeMonth, setActiveMonth] = useState<string | null>("");
  const handleMonthClick = (month: string, i: any) => {
    setActiveMonth(month);
    setFormData({
      ...formData,
      expensesEnteredMonth: i,
    });
  };
  const [reportRequestBody, setReportRequestBody] = useState<any>();
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [loadingReport, setLoadingReport] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');

  const handleFieldChange = (field: any, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
    if(value === 'Between'){
      setSelectedValue('Between')
    }else if(selectedValue === 'Between' && (field !== 'submittedDateFilter')){
      setSelectedValue('Between')
    }else{
      setSelectedValue('')
    }
  };
  const Years = [
    "2024",
    "2023",
    "2022",
    "2021",
    "2020",
    "2019",
    "2018",
    "2017",
    "2016",
    "2015",
    "2014",
    "2013",
    "2012",
    "2011",
    "2010",
    "2009",
    "2008",
    "2007",
    "2006",
    "2005",
    "2004",
    "2003",
  ];

  const SubmittedDateFilters = [
    { value: "is", key: "On" },
    { value: "On or Before", key: "Before" },
    { value: "After", key: "After" },
    { value: "Between", key: "Between" },
  ];

  const searchCriteria = [
    { key: "LESSER_THAN_OR_EQUALS_TO", value: "<=" },
    { key: "GREATER_THAN_OR_EQUALS_TO", value: ">=" },
    { key: "EQUALS", value: "=" },
    { key: "BETWEEN", value: "><" },
  ];

  const monthsList = [
    { label: "Select", value: 13 },
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ];

  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  const Status = ["Approved", "Rejected", "Pending", "Submitted", "Filed"];

  const tableColumns = [
    { ID: "referenceNumber", fieldName: "Reference Number" },
    { ID: "shortTitle", fieldName: "Short Title" },
    { ID: "amount", fieldName: "Amount" },
    { ID: "status", fieldName: "Status" },
    { ID: "submittedBy", fieldName: "Submitted By" },
    { ID: "submittedOn", fieldName: "Submitted On" },
    { ID: "dueDate", fieldName: "Due Date" },
    { ID: "vendor", fieldName: "Vendor" },
    { ID: "account", fieldName: "Account" },
    { ID: "checkNumber", fieldName: "Check Number" },
    { ID: "checkMailedDate", fieldName: "Checked Mail Date" },
    { ID: "authorizedBy", fieldName: "Authorized By" },
  ];
  const checkBoxSequence = [
    { ID: "shortTitle", fieldName: "Short Title" },
    { ID: "amount", fieldName: "Amount" },
    { ID: "status", fieldName: "Status" },
    { ID: "submittedBy", fieldName: "Submitted By" },
    { ID: "submittedOn", fieldName: "Submitted On" },
    { ID: "dueDate", fieldName: "Due Date" },
    { ID: "vendor", fieldName: "Vendor Name" },
    { ID: "account", fieldName: "Account" },
    { ID: "referenceNumber", fieldName: "Reference Number" },
    { ID: "checkNumber", fieldName: "Check Number" },
    { ID: "checkMailedDate", fieldName: "Checked Mail Date" },
    { ID: "authorizedBy", fieldName: "Authorized By" },
  ];
  const initialCheckedItems = tableColumns.reduce((acc, item) => {
    acc[item.ID] = true;
    return acc;
  }, {} as { [key: string]: boolean });

  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>(
    initialCheckedItems
  );
  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: "/temple/expenseAccounts/categories",
      includeToken: true,
    })
      .then((res) => {
        setAuthorizations(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    getGrandSummary();
  }, [formData.budgetYear]);

  const getGrandSummary = () => {
    apiRequest({
      method: "GET",
      endpoint: `/temple/expenseReports/accounts/budgetSummary/years/${formData.budgetYear}`,
      includeToken: true,
    })
      .then((res) => {
        setGrandSummaryData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePrint = (referenceNum: any) => {
    setOpenExpenseRequestDialog(true);
    setReferenceNumber(referenceNum);
  };
  const handleView = (referenceNum: any) => {
    setOpenExpenseRequestDialog(true);
    setViewRequestDetails(true);
    setReferenceNumber(referenceNum);
  };

  const handleClose = (): void => {
    setOpenCancelDialog(false);
    setPageNumber(1);
  };

  const amountFilter = (reqBody: any) => {
    switch (formData.amountSecond) {
      case "LESSER_THAN_OR_EQUALS_TO":
        return {
          ...reqBody,
          amountMax: formData.amountThird,
        };
      case "GREATER_THAN_OR_EQUALS_TO":
        return {
          ...reqBody,
          amountMin: formData.amountFirst,
        };
      case "EQUALS":
        return {
          ...reqBody,
          amountMin: formData.amountFirst,
          amountMax: formData.amountThird,
        };
      case "BETWEEN":
        return {
          ...reqBody,
          amountMin: formData.amountFirst,
          amountMax: formData.amountThird,
        };
      default:
        break;
    }
  };

  const submittedDateFilter = (reqBody: any) => {
    switch (formData.submittedDateFilter) {
      case "BEFORE":
        return {
          ...reqBody,
          submittedDate2: formData.submittedDateTwo,
        };
      case "AFTER":
        return {
          ...reqBody,
          submittedDate1: formData.submittedDateOne,
        };
      case "ON":
        return {
          ...reqBody,
          submittedDate1: formData.submittedDateOne,
          submittedDate2: formData.submittedDateTwo,
        };
      case "BETWEEN":
        return {
          ...reqBody,
          submittedDate1: formData.submittedDateOne,
          submittedDate2: formData.submittedDateTwo,
        };
      default:
        break;
    }
  };

  const handleOpenDialog = () => {
    setOpenCancelDialog(true);
    const reqBody = {
      ...(formData.budgetYear && { budgetYear: Number(formData.budgetYear) }),
      ...(formData.expensesEnteredMonth && {
        expensesEnteredMonth: formData.expensesEnteredMonth,
      }),
      // ...(formData.shortTitle && { referenceNumber: formData.shortTitle }),
      ...(formData.checkedMailYear && {
        checkMailedYear: Number(formData.checkedMailYear),
      }),
      ...(formData.submittedDateTwo && {
        submittedDate2: dayjs(formData.submittedDateTwo).format("MM-DD-YYYY"),
      }),
      ...(formData.submittedDateOne && {
        submittedDate1: dayjs(formData.submittedDateOne).format("MM-DD-YYYY"),
      }),
      ...(formData.submittedBy && { accountSubmittedBy: formData.submittedBy }),
      ...(formData.authorizedBy && { authorizedBy: formData.authorizedBy }),
      ...(formData.amountSecond && { amountFilter: formData.amountSecond }),
      ...(formData.amountFirst && { amountMin: Number(formData.amountFirst) }),
      ...(formData.amountThird && { amountMax: Number(formData.amountThird) }),
      ...(formData.status && { status: formData.status.toUpperCase() }),
      ...(formData.checkedMailMonth && {
        checkMailedMonth: formData.checkedMailMonth,
      }),
      ...(isDevoteeSponsered && { devoteeSponsored: true }),
      ...(formData.shortTitle && { shortTitle: formData.shortTitle }),
      ...(formData.submittedDateFilter && {
        submittedDateFilter: formData.submittedDateFilter.toUpperCase(),
      }),
    };
    amountFilter(reqBody);
    submittedDateFilter(reqBody);
    setReportRequestBody(reqBody);
    setLoadingReport(true);
    apiRequest({
      method: "POST",
      endpoint: "/temple/expenseReports/accounts/custom",
      includeToken: true,
      params: {
        sortBy: "reference_no",
        page: pageNumber - 1,
        size: 50,
        direction: "asc",
      },
      body: JSON.stringify(reqBody),
    })
      .then((res: any) => {
        setLoadingReport(false);
        setReportData(res.data.content);
        setTotalRecords(res.data.totalElements);
      })
      .catch((err) => {
        setLoadingReport(false);
        console.log(err);
      });
  };

  const handleCheckboxChange = (id: any) => {
    const newCheckedItems = { ...checkedItems, [id]: !checkedItems[id] };
    setCheckedItems(newCheckedItems);
  };
  const ExportToExcel = async () => {
    setLoading(true);
    const reqBody = {
      shortTitle: checkedItems.shortTitle,
      amount: checkedItems.amount,
      status: checkedItems.status,
      submittedBy: checkedItems.submittedBy,
      submittedOn: checkedItems.submittedOn,
      dueDate: checkedItems.dueDate,
      vendorName: checkedItems.vendor,
      account: checkedItems.account,
      referenceNumber: checkedItems.referenceNumber,
      checkNumber: checkedItems.checkNumber,
      checkMailedDate: checkedItems.checkMailedDate,
      customExpenseReportFilter: reportRequestBody,
      authorizedBy:checkedItems.authorizedBy,
    };
    const endpoint = "/temple/expenseReports/accounts/custom/excel";

    const response = await apiRequest({
      method: "POST",
      endpoint: endpoint,
      body: JSON.stringify(reqBody),
      includeToken: true,
      responseType: "arraybuffer",
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.download = "Custom_Report.xlsx";
    link.href = window.URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setLoading(false);
  };

  const BudgetYearDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelect
          sx={{ color: "#000" }}
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="budgetYear"
          placeholder="Select Year"
          onChange={(e) => {
            handleFieldChange("budgetYear", e.target.value);
          }}
          value={formData.budgetYear}
          className={styles.textField}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {Years.map((item, i) => (
            <CustomMenuItem value={item} key={i}>
              {item}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const CheckedMonthDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelectField
          id="month"
          handleDropdownChange={handleFieldChange}
          errorMessage={""}
          dropDownList={monthsList}
          value={formData.checkedMailMonth}
          fieldName="checkedMailMonth"
          placeholder="Select Month"
          optionLabel="label"
          optionValue="value"
        />
      </FormControl>
    );
  };

  const CheckedYearDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelect
          sx={{ color: "#000" }}
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="checkedYear"
          placeholder="Select Year"
          onChange={(e) => {
            handleFieldChange("checkedMailYear", e.target.value);
          }}
          value={formData.checkedMailYear}
          className={styles.textField}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {Years.map((item, i) => (
            <CustomMenuItem value={item} key={i}>
              {item}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const SubmittedByDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelectField
          id="submittedBy"
          handleDropdownChange={handleFieldChange}
          errorMessage={""}
          dropDownList={authorizations}
          value={formData.submittedBy}
          fieldName="submittedBy"
          placeholder="Select"
          optionLabel="categoryName"
          optionValue="categoryName"
        />
      </FormControl>
    );
  };

  const AuthorizedByDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelectField
          id="authorizedBy"
          handleDropdownChange={handleFieldChange}
          errorMessage={""}
          dropDownList={authorizations}
          value={formData.authorizedBy}
          fieldName="authorizedBy"
          placeholder="Select"
          optionLabel="categoryName"
          optionValue="categoryName"
        />
      </FormControl>
    );
  };

  const AmountTwoDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelectField
          id="amountTwo"
          handleDropdownChange={handleFieldChange}
          errorMessage={""}
          dropDownList={searchCriteria}
          value={formData.amountSecond}
          fieldName="amountSecond"
          placeholder="Select Serach Criteria"
          optionLabel="value"
          optionValue="key"
        />
      </FormControl>
    );
  };

  const SubmittedDateDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelectField
          id="submittedDateFilter"
          handleDropdownChange={handleFieldChange}
          errorMessage={""}
          dropDownList={SubmittedDateFilters}
          value={formData.submittedDateFilter}
          fieldName="submittedDateFilter"
          placeholder="Select"
          optionLabel="value"
          optionValue="key"
        />
      </FormControl>
    );
  };
  const submittedDateTwoPicker = (): React.ReactElement => {
    return (
      <Box>
        <StyledDateContainer
          id="submittedDatetwo"
          className={styles.dateField}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formData.submittedDateTwo
                    ? dayjs(formData.submittedDateTwo, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  handleFieldChange("submittedDateTwo", value);
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </Box>
    );
  };
  const submittedDateOnePicker = (): React.ReactElement => {
    return (
      <Box>
        <StyledDateContainer
          id="submittedDateOne"
          className={styles.dateField}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formData.submittedDateOne
                    ? dayjs(formData.submittedDateOne, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  handleFieldChange("submittedDateOne", value);
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </Box>
    );
  };

  const StatusDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelect
          sx={{ color: "#000" }}
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="status"
          placeholder="Select"
          onChange={(e) => {
            handleFieldChange("status", e.target.value);
          }}
          value={formData.status}
          className={styles.textField}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {Status.map((item, i) => (
            <CustomMenuItem value={item} key={i}>
              {item}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const TableRowsDisplayingCheckBoxes = () => {
    return (
      <>
        <Box style={{ width: "100%" }} className={styles.CheckBoxContainer}>
          {CustomRequiredInputLabel("Fields", true)}
          <Box className={styles.AllCheckboxes}>
            {checkBoxSequence.map((item) => (
              <Box key={item.ID}>
                <FormControlLabel
                  control={
                    <CustomCheckbox
                      id={`${item.ID}`}
                      size="medium"
                      checked={checkedItems[item.ID]}
                      onChange={() => handleCheckboxChange(item.ID)}
                    />
                  }
                  label={item.fieldName}
                />
              </Box>
            ))}
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: "16px", marginTop: "16px" }}>
          <CommonButton onClick={handleOpenDialog}>
            Generate Report
          </CommonButton>
          <CommonOutlinedButton onClick={handleClear}>
            Reset
          </CommonOutlinedButton>
        </Box>
      </>
    );
  };

  const renderFieldComponents = () => {
    return (
      <Box className={styles.fieldConatiner}>
        <Grid container spacing={2} className={styles.rowGrid}>
          <Grid item xs={12} sm={4}>
            {CustomRequiredInputLabel("Budget Year", true)}
            {BudgetYearDropdown()}
          </Grid>
          <Grid xs={12} sm={2} item>
            {CustomRequiredInputLabel("Check Mailed Year", false)}
            {CheckedYearDropdown()}
          </Grid>
          <Grid xs={12} sm={2} item>
            {CustomRequiredInputLabel("Check Mailed Month", false)}
            {CheckedMonthDropdown()}
          </Grid>
          <Grid item xs={12} sm={4}>
            {CustomRequiredInputLabel("Submitted By", false)}
            {SubmittedByDropdown()}
          </Grid>
        </Grid>
        <Grid container spacing={2} className={styles.rowGrid}>
          <Grid xs={12} sm={4} item>
            {CustomRequiredInputLabel("Authorized By", false)}
            {AuthorizedByDropdown()}
          </Grid>
          <Grid xs={12} sm={1.333} item>
            {CustomRequiredInputLabel("Amount", false)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.amountFirst}
              onChange={(e) => {
                const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                handleFieldChange("amountFirst", inputValue);
              }}
              className={styles.textField}
              placeholder="Enter Amount"
            />
          </Grid>
          <Grid xs={12} sm={1.333} item sx={{ marginTop: "20px" }}>
            {AmountTwoDropdown()}
          </Grid>
          <Grid xs={12} sm={1.333} item sx={{ marginTop: "20px" }}>
            <CustomTextFeild
              fullWidth
              required
              value={formData.amountThird}
              onChange={(e) => {
                const inputValue = e.target.value.replace(/[^0-9.]/g, "");
                handleFieldChange("amountThird", inputValue);
              }}
              className={styles.textField}
              placeholder="Enter Amount"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            {CustomRequiredInputLabel("Short Title", false)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.shortTitle}
              onChange={(e) => {
                handleFieldChange("shortTitle", e.target.value);
              }}
              className={styles.textField}
              placeholder="Enter Title"
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} className={styles.rowGrid}>
          <Grid xs={12} sm={4} item>
            {CustomRequiredInputLabel("Submitted Date Filter", false)}
            {SubmittedDateDropdown()}
          </Grid>
          <Grid xs={12} sm={2} item>
            {CustomRequiredInputLabel("Submitted Date", false)}
            {submittedDateOnePicker()}
          </Grid>
          {selectedValue === "Between" && (
            <Grid xs={12} sm={2} item sx={{ marginTop: "20px" }}>
              {CustomRequiredInputLabel("", false)}
              {submittedDateTwoPicker()}
            </Grid>
          )}
          <Grid xs={12} sm={4} item>
            {CustomRequiredInputLabel("Status", false)}
            {StatusDropdown()}
          </Grid>
        </Grid>
      </Box>
    );
  };

  const selectedColumns = Object.keys(checkedItems).filter(
    (key) => checkedItems[key]
  );

  const handlePrintBrowser = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Custom_Report`,
  });

  useEffect(() => {
    if (formData.expensesEnteredMonth !== "") {
      handleOpenDialog();
    }
  }, [formData.expensesEnteredMonth]);

  useEffect(() => {
    if (pageNumber > 1) {
      handleOpenDialog();
    }
  }, [pageNumber]);

  const GeneratedReportTable = () => {
    return (
      <Box sx={{ width: "100%" }}>
        {
          <BounceLoader
            color="#22A699"
            loading={loadingReport}
            size={45}
            style={{
              position: "sticky",
              top: "50%",
              left: "50%",
              zIndex: "999",
            }}
          />
        }
        <StyledTableContainer ref={componentRef} id="generatedTable">
          <StyledTable aria-label="customized table">
            <TableHead>
              <TableRow>
                {ReportData && <StyledTableCell>Sr.No</StyledTableCell>}
                {selectedColumns.map((columnId) => {
                  const row = tableColumns.find((row) => row.ID === columnId);
                  return (
                    <StyledTableCell key={columnId}>
                      {row ? row.fieldName : ""}
                    </StyledTableCell>
                  );
                })}
                {ReportData && <StyledTableCell className="no_print">Action</StyledTableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {ReportData.length === 0 && (
                <Typography
                  sx={{
                    margin: "24px auto",
                    color: "red",
                    fontSize: "28px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <b>No Records found</b>
                </Typography>
              )}
              {ReportData &&
                ReportData?.map((row: any, rowIndex: any) => (
                  <StyledTableRow key={rowIndex}>
                    <StyledTableCell>
                      {rowIndex + 1 + (pageNumber - 1) * 50}
                    </StyledTableCell>
                    {selectedColumns.map((columnId) => (
                      <StyledTableCell
                        key={columnId}
                        sx={{
                          textWrap: "balance",
                          width: "250px",
                          maxWidth: "fit-content",
                          wordBreak: "break-all",
                          // minWidth: { xs: "90px", md: "250px" },
                        }}
                      >
                        {columnId === "shortTitle" ? (
                          <Typography
                            sx={{
                              textDecoration: "underline",
                              cursor: "pointer",
                              maxWidth: "fit-content",
                              wordBreak: "break-all",
                              // minWidth: { xs: "90px", md: "250px" },
                            }}
                            onClick={() => handleView(row?.referenceNumber)}
                          >
                            {row[columnId]}
                          </Typography>
                        ) : (
                          row[columnId]
                        )}
                      </StyledTableCell>
                    ))}
                    <StyledTableCell className="no_print">
                      <Box
                        component={"img"}
                        src={printIcon}
                        alt="Print"
                        onClick={() => handlePrint(row?.referenceNumber)}
                        sx={{
                          cursor: "pointer",
                          mr: { xs: "10px", md: "15px" },
                        }}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </StyledTable>
        </StyledTableContainer>
      </Box>
    );
  };

  const MonthsComponentInGeneratedReport = () => {
    return (
      <>
        <Box className={styles.MonthlyLayout}>
          <Box style={{ marginTop: "20px" }}>
            <Box className={styles.buttonContainer}>
              {months.map((month, i) => (
                <Button
                  id="monthClick"
                  key={month}
                  onClick={() => handleMonthClick(month, i + 1)}
                  className={
                    activeMonth === month ? `${styles.activeButton}` : ""
                  }
                >
                  <span style={{ textTransform: "none" }}>{month}</span>
                </Button>
              ))}
            </Box>
          </Box>
          <Box style={{ borderBottom: "2px solid #D4E2EA" }}></Box>
        </Box>
      </>
    );
  };

  const GrandSummaryTableInGeneratedReport = () => {
    return (
      <Box className={styles.GrandSummaryTable} id="expense_details">
        <Typography className={styles.grandHeading}>Grand Summary</Typography>
        <StyledTableContainer sx={{ width: "100%" }} id="grandSummary">
          <StyledTable aria-label="customized table">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>Total</StyledTableCell>
                <StyledTableCell>Total Budget</StyledTableCell>
                <StyledTableCell>Total Expense</StyledTableCell>
                <StyledTableCell>Total Remaining</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {grandSummaryData === "" && (
                <Typography
                  sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}
                >
                  <b>No Records found</b>
                </Typography>
              )}
              <StyledTableCell>
                {grandSummaryData &&
                  `${grandSummaryData?.totalExpensePercentage}% used`}
              </StyledTableCell>
              <StyledTableCell>
                {grandSummaryData &&
                  formatAmount(grandSummaryData?.totalBudgetAmount)}
              </StyledTableCell>
              <StyledTableCell>
                {grandSummaryData &&
                  formatAmount(grandSummaryData?.totalExpenseAmount)}
              </StyledTableCell>
              <StyledTableCell>
                {grandSummaryData &&
                  formatAmount(grandSummaryData?.totalRemainingAmount)}
              </StyledTableCell>
            </TableBody>
          </StyledTable>
        </StyledTableContainer>
      </Box>
    );
  };

  const PrintAndDownloadButtons = () => {
    return (
      <Box
        sx={{
          margin: "32px 0 18px 0",
          display: "flex",
          gap: "16px",
          float: "right",
        }}
      >
        <CommonButton
          id="print"
          onClick={handlePrintBrowser}
          disabled={ReportData.length === 0}
        >
          Print
        </CommonButton>
        <CommonButton
          id="download"
          onClick={ExportToExcel}
          disabled={ReportData.length === 0}
        >
          <ButtonLoader isBtnLoading={loading} btnText={"Export To Excel"} />
        </CommonButton>
      </Box>
    );
  };

  const DetailedPopOverInfoAboutReport = () => {
    return (
      <Box>
        <MonthsComponentInGeneratedReport />
        <GrandSummaryTableInGeneratedReport />
        {PrintAndDownloadButtons()}
        <GeneratedReportTable />
        {totalRecords > 50 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              mr: "20px",
              py: "10px",
            }}
          >
            <Pagination
              items={totalRecords}
              itemsPerPage={50}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
            />
          </Box>
        ) : (
          ""
        )}
        <CommonButton onClick={handleClose} id="close">
          Close
        </CommonButton>
      </Box>
    );
  };

  const handleClear = () => {
    setFormData(formFieldsCustomReport);
  };

  const dialogBoxOpen = (): React.ReactElement => {
    return (
      <>
        <Dialog
          open={openCancelDialog}
          onClose={handleClose}
          aria-labelledby="cancel-dialog-title"
          fullWidth
          maxWidth="xl"
          PaperProps={{
            style: {
              height: "calc(100% - 64px)",
              width: "calc(100% - 64px)",
              margin: "32px",
              maxWidth: "1148px",
              maxHeight: "644px",
              overflowY: "hidden",
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
            },
          }}
        >
          <Box
            style={{
              backgroundColor: "#882E14",
              width: "auto",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"Expense Report"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </Box>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-slide-description"
              className={styles.MainCutomReportContainer}
            >
              {DetailedPopOverInfoAboutReport()}
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </>
    );
  };

  return (
    <Box className={styles.MainCutomReportContainer}>
      <Typography className={styles.SubHeading}>Custom Reports</Typography>

      <Card className={styles.fields}>
        {renderFieldComponents()}
        <Grid sx={{ display: "flex", margin: "24px 0 0 -8px" }}>
          <CustomCheckbox
            id="checkSponsered"
            checked={isDevoteeSponsered}
            onChange={() => setIsDevoteeSponsered(!isDevoteeSponsered)}
          />
          <CustomInputLabel sx={{ marginTop: "6px", marginRight: "16px" }}>
            Devotee Sponsered ?
          </CustomInputLabel>
        </Grid>
        <Divider sx={{ color: "#000", width: "100%", margin: "16px 0" }} />
        {TableRowsDisplayingCheckBoxes()}
      </Card>
      {dialogBoxOpen()}
      {openExpenseRequestDialog && (
        <ViewExpenseRequest
          open={openExpenseRequestDialog}
          handleClose={() => {
            setOpenExpenseRequestDialog(false);
            setReferenceNumber("");
            setViewRequestDetails(false);
          }}
          referenceNumber={referenceNumber}
          viewRequest={viewRequestDetails}
        />
      )}
    </Box>
  );
};

export default CustomReport;
